<template lang="pug">
  v-dialog(v-model="show" persistent max-width="1000px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable)
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    v-card(flat max-width="1000px" )
      v-card-title {{getTitle}}
      v-card-text.pa-1.pa-md-2
        v-row.ma-0
          v-col.pa-0.pl-2.pr-2.pb-4.pt-2(cols="12" md="6")
            v-card.elevation-2.pa-0
              v-card-title(align="center" justify="center") {{ $t('requestPage.requestBoarder') }}
              v-card-text.pb-0(v-if="boarderRequest")
                v-form(ref="form" v-model="isFormValid" :disabled="isSaveInProgress" )
                  v-row.ma-0
                    v-col.py-0(cols="12")
                      v-text-field(
                        v-model="boarderRequest.data.firstName"
                        :label="$t('requestPage.firstName')" outlined prepend-icon="fas fa-user" required
                      :dense="$vuetify.breakpoint.mdAndUp" :rules="givenNameRules"
                      )
                    v-col.py-0(cols="12")
                      v-text-field(
                        v-model="boarderRequest.data.familyName" prepend-icon="as fa-user"
                        :label="$t('requestPage.familyName')" outlined required
                      :dense="$vuetify.breakpoint.mdAndUp" :rules="familyNameRules"
                      )
                  v-row.ma-0
                    v-col.py-0(cols="12" md="12")
                      v-text-field(
                        v-model="boarderRequest.data.email"
                        :label="$t('requestPage.email')"  outlined prepend-icon="fas fa-envelope"
                        :dense="$vuetify.breakpoint.mdAndUp" :rules="emailRules"
                      )
                    v-col.py-0(cols="12" md="12")
                      v-text-field(
                        v-model="boarderRequest.data.phoneNumber"
                        :label="$t('requestPage.phoneNumber')"  outlined prepend-icon="fas fa-phone"
                        :dense="$vuetify.breakpoint.mdAndUp"
                      )
                    v-col.py-0(cols="12" md="12")
                      v-select(
                        v-model="currentCustomer"
                        append-icon="fas fa-chevron-down" :label="$t('requestPage.customer')" prepend-icon="fas fa-user-tie"
                        outlined item-value="id" item-text="name" return-object :rules="currentCustomerRules"
                        :items="customerListActual" :dense="$vuetify.breakpoint.mdAndUp" :loading="isLoading"
                      )
                    v-col.py-0(cols="12" md="12")
                      v-select(
                        v-model="currentBoarderGroup"
                        append-icon="fas fa-chevron-down" :label="$t('requestPage.boarderGroup')"
                        outlined item-value="id" item-text="name" return-object prepend-icon="fas fa-house-user"
                        :items="filteredGroupList"
                        :dense="$vuetify.breakpoint.mdAndUp" :loading="isLoading" :rules="currentBoarderGroupRules" )
                  v-row.ma-0()
                    v-col.py-0.pb-2(cols="12" md="12" v-if="boarderRequest.data.alreadyHaveAccount" )
                      v-icon.pb-2 fas fa-check-square
                      span.pl-4.font-weight-bold.text-wrap(v-if="boarderRequest.data.alreadyHaveAccount" ) {{ $t('requestPage.alreadyHaveAccountActive') }}
                    v-col.py-0.pb-2.pl-4(cols="12" md="12" v-else )
                      span.pl-4.font-weight-bold * {{ $t('requestPage.alreadyHaveAccountUnActive') }}
          v-col.pa-0(cols="12" md="6")
            v-card.elevation-0(width="1000px" )
              v-card-text.py-0
                v-form(ref="form" v-model="isForm1Valid" lazy-validation )
                  v-row.ma-0
                    v-col.pt-2.pa-0(cols="12")
                      v-text-field(outlined :label="$t('requestPage.arciveSearch')"  v-model="name" dense loading="isFetchData" @input="onFilterTextInput"
                      )

                v-row.ma-0.mt-0
                  v-col.pa-0(cols="12")
                    v-card.elevation-0.pa-0()
                      v-card-text.pa-0.pr-4.mb-2(style="height: 41vh; overflow-y: scroll" v-if="$vuetify.breakpoint.mdAndUp")
                        v-row.ma-0.title(v-if="foundBorder.length == 0 && isSearch && archivedBoarder && archivedBoarder.length && !isFetchArchive" justify="center" ) {{ $t('addBoarderDialog.searchBoarderNameIsNotExist') }}
                        v-list(v-if="foundBorder && !isFetchArchive" dense v-for="(item,idx) in foundBorder" :key="idx"  )
                            v-card( :loading="isFetchData" @click="selectBoarder(item)")
                              v-card-text.pa-0()
                                v-row.ma-0(align="center" justify="center" )
                                  v-col.text-center.align-center.justify-space-around.align-content-space-around(cols="2" align="center" justify="center")
                                    v-icon(align="center" justify="center" :color="getColor(item)" fab) {{getIcon(item)}}
                                  v-col(cols="10")
                                    v-list-item-title.title {{item.person.firstName}} {{item.person.familyName}}
                                    v-list-item-subtitle {{item.customer.name}} ({{item.boarderGroupCollection[0].name}})
                                    v-list-item-subtitle(v-for="(i,idx) in getEmail(item.person.id) " :key="idx") {{i.email}}
                                    v-list-item-subtitle(v-for="(a,idx) in getPhone(item.person.id)" :key="idx") {{a.phoneNumber}}
                                    v-list-item-subtitle.text-end(cols="12" v-if="latestReservations && latestReservations.length > 0 && $vuetify.breakpoint.mdAndUp")  {{ $t('requestPage.latestReservations') }}: {{getLastDate(item)}}
                                    v-list-item-subtitle.text-end(cols="12" v-if="latestReservations && latestReservations.length < 1  && $vuetify.breakpoint.mdAndUp")   {{getLastDate(item)}}
                                    v-list-item-subtitle.text-end(cols="12" v-if="latestReservations && $vuetify.breakpoint.smAndDown") {{getLastDate(item)}}
                        v-row.ma-0(v-if="isFetchArchive" align="center" justify="center" )
                          v-col.text-center(cols="12" align="center" justify="center" )
                            v-progress-circular.loader( color="primary" value="80" indeterminate size="50" )
                      v-card-text.pa-0.pr-4.mb-2(
                        v-else)
                        v-row.ma-0.title(v-if="foundBorder.length == 0 && isSearch" justify="center" ) {{ $t('addBoarderDialog.searchBoarderNameIsNotExist') }}
                        v-list(v-if="foundBorder && !isFetchArchive" dense v-for="(item,idx) in foundBorder" :key="idx"  )
                          v-card( :loading="isFetchData" @click="selectBoarder(item)")
                            v-card-text.pa-0()
                              v-row.ma-0(align="center" justify="center" )
                                v-col.text-center.align-center.justify-space-around.align-content-space-around(cols="2" align="center" justify="center")
                                  v-icon(align="center" justify="center" :color="getColor(item)" fab) {{getIcon(item)}}
                                v-col(cols="10")
                                  v-list-item-title.title {{item.person.firstName}} {{item.person.familyName}}
                                  v-list-item-subtitle {{item.customer.name}} ({{item.boarderGroupCollection[0].name}})
                                  v-list-item-subtitle(v-for="(i,idx) in getEmail(item.person.id) " :key="idx") {{i.email}}
                                  v-list-item-subtitle(v-for="(a,idx) in getPhone(item.person.id)" :key="idx") {{a.phoneNumber}}
                                  v-list-item-subtitle.text-end(cols="12" v-if="latestReservations && latestReservations.length > 0 && $vuetify.breakpoint.mdAndUp")  {{ $t('requestPage.latestReservations') }}: {{getLastDate(item)}}
                                  v-list-item-subtitle.text-end(cols="12" v-if="latestReservations && latestReservations.length < 1  && $vuetify.breakpoint.mdAndUp")   {{getLastDate(item)}}
                                  v-list-item-subtitle.text-end(cols="12" v-if="latestReservations && $vuetify.breakpoint.smAndDown") {{getLastDate(item)}}
                        v-row.ma-0(v-if="isFetchArchive" align="center" justify="center" )
                          v-col.text-center(cols="12" align="center" justify="center" )
                            v-progress-circular( color="primary" value="80" indeterminate size="50" )
                    v-row.ma-0.pt-1()
                      v-col.text-center.pa-0(cols="12" v-if="name && selectedBoarder")
                        v-alert.text--white(color="orange" dense) {{ $t('requestPage.personFromArchiveMessage', {boarderName:getFullName} )}}
                      v-col.text-center.pa-0(cols="12" v-if="!selectedBoarder")
                        v-alert.text--white(color="orange" dense) {{ $t('requestPage.personNewCreateMessage', {boarderName:getFullName} )}}




      v-divider
      v-card-actions(v-if="$vuetify.breakpoint.mdAndUp")
        v-btn(color="primary" text  @click="onCloseButtonClick(isSnackbar)" :disabled="isCreate") {{ $t('addBoarderDialog.closeButtonLabel') }}
        v-spacer
        v-btn( @click="onRejectedSubmitButtonClick" :disabled="!valid || isCreate"  ) {{ $t('requestPage.rejectedButtonLabel') }}
        v-btn(color="primary" @click="onSubmitButtonClick" :disabled="!valid" :loading="isCreate") {{ $t('requestPage.acceptedButtonLabel') }}
      v-card-actions(v-else)
        v-btn(color="primary" text  @click="onCloseButtonClick(isSnackbar)" :disabled="isCreate") {{ $t('addBoarderDialog.closeButtonLabel') }}
        v-spacer
        v-btn( @click="onRejectedSubmitButtonClick" :disabled="!valid || isCreate"  :loading="isCreate") {{ $t('requestPage.rejectedButton') }}
        v-btn(color="primary" @click="onSubmitButtonClick" :disabled="!valid" :loading="isCreate") {{ $t('requestPage.acceptedButton') }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import {
  ACCEPTED_REQUEST,
  BOARDER_FETCH_BOARDER_GROUP_LIST,
  CUSTOMER_FETCH_CUSTOMER_LIST,
  FETCH_ARCHIVED_BOARDER_LIST,
  FETCH_BOARDER_DETAIL,
  FETCH_BOARDER_DETAIL_WITH_CANCEL,
  FETCH_LATEST_RESERVATIONS,
  REMOVE_BOARDER_FROM_ARCHIVE
} from '@/store/action-types'
import i18n from "@/i18n";
import {TranslateResult} from "vue-i18n";
import _ from "lodash"
import {BoarderDetailResponse} from "@/types/service-response";
import Boarder from "@/model/boarder/Boarder";
import moment from "moment";
import Customer from "@/model/customer/Customer";
import BoarderGroup from "@/model/boarder/BoarderGroup";
import LatestReservation from "@/model/LatestReservation";
import axios, {CancelTokenSource} from "axios";
import PersonDetail from "@/model/PersonDetail";
import {DataWithCancelPayload, RequestPayload} from "@/types/payload";
import Request from "@/model/Request";
import ArchivedBoarder from "@/model/ArchivedBoarder";

function valueIsRequired(v: string): boolean | TranslateResult {
  return !!v || i18n.t('validation.valueIsRequired')
}

function validateEmail(v: string): boolean | TranslateResult {
  if (v) {
    return /.+@.+\..+/.test(v) || i18n.t('validation.emailMustBeValid')
  }

  return true
}

@Component({
  components: {
    props: {
        type: String,
        required: true
      }

  },
})
export default class RequestDetailDialog extends Vue {
  $refs!: {
    form: Vue & {
      validate(): boolean
      resetValidation(): boolean
    }
  }
  @Prop({ type: Boolean, default: false }) readonly show!: boolean
  @Prop({ type: Object, required: true }) readonly request!: Request

  @Action(ACCEPTED_REQUEST) acceptedRequest!: { (payload: RequestPayload): Promise<void> }
  @Action(FETCH_ARCHIVED_BOARDER_LIST) fetchArchivedBoarder!: { (): Promise<ArchivedBoarder[]> }
  @Action(FETCH_BOARDER_DETAIL_WITH_CANCEL) fetchDetailPerson!: { (payload: DataWithCancelPayload): Promise<BoarderDetailResponse> }
  @Action(REMOVE_BOARDER_FROM_ARCHIVE) removeBoarder!: { (payload: any): Promise<void> }
  @Action(FETCH_LATEST_RESERVATIONS) fetchLatestOfferReservations!: { (payload: DataWithCancelPayload): Promise<LatestReservation[]> }
  @Action(CUSTOMER_FETCH_CUSTOMER_LIST) fetchCustomerList!: { (): Promise<Customer[]> }
  @Action(BOARDER_FETCH_BOARDER_GROUP_LIST) fetchBoarderGroupList!: { (): Promise<BoarderGroup[]> }


  private isFetchData: boolean = false
  private checkBox: boolean = false
  private valid: boolean = true
  private saveInProgress: boolean = false
  private isFormValid: boolean = false
  private isForm1Valid: boolean = false
  private isSaveInProgress: boolean = false
  private isLoading: boolean = false
  private currentCustomer: Customer | null = null
  private currentBoarderGroup: any = null
  private name: string = ''
  private archivedBoarder: ArchivedBoarder[] = []
  private customerListActual: Customer[] = []
  private boarderListActual:  any[] = []
  private status: string = ''
  private isSearch: boolean = false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private givenNameRules = [
    valueIsRequired
  ]

  private familyNameRules = [
    valueIsRequired
  ]

  private emailRules = [
    valueIsRequired,
    validateEmail
  ]

  private currentCustomerRules = [
    valueIsRequired
  ]

  private currentBoarderGroupRules = [
    valueIsRequired
  ]
  private boarderRequest: Request | null = null
  private isNameInArchive: boolean = true
  private selectedBoarder: ArchivedBoarder | null = null
  private customer: number | null  = null
  private group: number | null  = null
  private personDetail: BoarderDetailResponse[] =[]
  private latestReservations: LatestReservation[] = []
  private foundBorder : any[] = []
  private isCreate: boolean = false
  private isSnackbar: boolean = false
  private snackbarStatus: any | null = null
  private lastReservationCancelToken: CancelTokenSource | null = null
  private personDetailCancelTokenList: Map<number, CancelTokenSource > = new Map()
  private isFetchArchive: boolean = true

  @Watch('currentCustomer')
  watchCurrentCustomer (newVal: any): void {
    if(newVal) {
      this.currentCustomer = newVal
    }
  }

  @Watch('currentBoarderGroup')
  watchCurrentBoarderGroup (newVal: any): void {
    if(newVal) {
      this.currentBoarderGroup = newVal
    }
  }

  @Watch('snackbarStatus')
  watchSnackbarStatus (newVal: any): void {
    if(newVal) {
      this.snackbarStatus = newVal
    }
  }

  @Watch('name')
  watchName (newVal: string): void {
    if (newVal && newVal.length >= 3) {
      this.searchBoarder()
    } else {
      this.foundBorder = []
    }

    this.selectedBoarder = null
    this.group = null
  }

  @Watch('checkBox')
  watchcheckBox (newVal: boolean): void {
    if(newVal) {
      this.checkBox = newVal
    }
  }


  getColor (item: Boarder): string {
    if (this.selectedBoarder && item.id === this.selectedBoarder.id) {
      return `success`
    } else {
      return ``
    }
  }

  getIcon (item: Boarder): string {
    if (this.selectedBoarder && item.id === this.selectedBoarder.id) {
      return `fas fa-check`
    } else {
      return `fas fa-ban`
    }
  }

  get getTitle(): string {
    if(this.boarderRequest && this.boarderRequest.kind.name === 'onboarding') {
       return this.$t('requestPage.newRequestTitle').toString()
    } else {
      return this.$t('requestPage.requestPageTitle').toString()
    }
  }

  getEmail (item: any): any[] {
    const foundDetail: any | undefined = this.personDetail!.find((i: any) => i.id === item)
    return foundDetail ? foundDetail.emails : []
  }



  getLastDate (item: any): string {
    const foundDetail: any | undefined = this.latestReservations.find((i: LatestReservation) => i.boarder.id === item.id)
    return foundDetail ?  moment(foundDetail.date).format('D.M.YYYY') : this.$t('requestPage.noLatestReservations').toString()
  }

  getPhone (item: number| null): any[] {
    const foundDetail: any | undefined = this.personDetail.find((i: any) => i.id === item)
    return foundDetail ? foundDetail.phoneNumbers : []
  }

  getDate (item: any) {
    return moment(item).format('D.M.YYYY')
  }

  get getFullName (): string {
    let firstName: string = ''
    let familyName: string = ''
    if(this.boarderRequest && this.boarderRequest.data) {
       firstName = this.boarderRequest.data.firstName
       familyName = this.boarderRequest.data.familyName
    }

    return `${firstName + ' ' + familyName}`
  }

  get filteredGroupList(): any[] {
    return this.boarderListActual.filter((g) => g.customer.id === this.currentCustomer?.id)

  }

  getfilteredArchivedBoarder():any {
    this.isFetchArchive = true
    const filteredData: any = this.archivedBoarder.filter((item: any) => {
      if(`${item.person.firstName.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '').toLowerCase()}${item.person.familyName.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '').toLowerCase()}`.replace(/\s/g, '').trim().includes(this.name.replace(/\s/g, '').trim().normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '').toLowerCase())) {
        return item
      } else if (`${item.person.familyName.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '').toLowerCase()}${item.person.firstName.normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '').toLowerCase()}`.replace(/\s/g, '').trim().includes(this.name.replace(/\s/g, '').trim().normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '').toLowerCase())) {
        return item
      }
    })
    this.isFetchArchive = false
    return filteredData
  }

  selectBoarder (item: ArchivedBoarder) {
    this.selectedBoarder = item
  }

  searchBoarder () {
    if(this.name && this.name.length >= 3) {
      this.isFetchArchive = true
      this.isFetchData = true
      this.isSearch = true
      this.foundBorder = []
      this.personDetail = []
      this.personDetailCancelTokenList.forEach((values) => {
        values.cancel()
      })
      this.personDetailCancelTokenList.clear()
      this.foundBorder = this.getfilteredArchivedBoarder()
      this.checkBox = false
      let payload: DataWithCancelPayload = {data: '', cancelToken: null}
      let payload1: DataWithCancelPayload = {data: '', cancelToken: null}

      this.foundBorder.forEach((a: any) => {
        if (a) {
          payload1.data = a.person.id
          payload.data += `boarder.id[]=${a.person.id}&`
          this.detailPersonClick(payload1)
        }
      })
      if (payload.data) {
        this.fetchLastReservation(payload)
      }
      this.isFetchArchive = false
    }
  }

  getList() {
    this.isFetchData  = true
    if(this.archivedBoarder && this.archivedBoarder.length < 1) {
      this.isNameInArchive = false
    }
    this.isFetchData  = false
  }

  onCloseButtonClick (item: boolean,status: string | undefined) {
    this.$emit('close', item, status)
  }

  onFilterTextInput() {
  }

  onSubmitButtonClick () {
    this.status = 'approved'
    this.acceptRequest(this.status)
  }

  onRejectedSubmitButtonClick () {
    this.status = 'rejected'
    this.acceptRequest(this.status)
  }

  async detailPersonClick (item1: any): Promise<void> {
    this.checkBox = false
    this.isFetchData = true

    this.personDetailCancelTokenList.set(item1.data, axios.CancelToken.source())
    item1.cancelToken = this.personDetailCancelTokenList.get(item1.data)

    try {
      const response = await this.fetchDetailPerson(item1)
      this.personDetail.push(response)
      this.checkBox = false
      this.isFetchData = false
      this.personDetailCancelTokenList.delete(item1.data)
    } catch (e) {
      if ((e as any).isCancel(e )) {

      } else {
        this.showSnackBar = true
        this.snackBarColor = 'error'
        this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
      }
    }
  }


  async fetchArchiveList():Promise<void>{
    try {
      this.isFetchArchive = true
      this.archivedBoarder = await this.fetchArchivedBoarder()
      this.isFetchArchive = false
      this.searchBoarder()
      this.getList()
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
    }
  }

  async fetchLastReservation (payload: DataWithCancelPayload):Promise<void> {
    if (this.lastReservationCancelToken) {
      this.lastReservationCancelToken.cancel()
    }
    this.lastReservationCancelToken = axios.CancelToken.source()
    payload.cancelToken = this.lastReservationCancelToken
    try {
      this.isFetchData = true
      const response = await this.fetchLatestOfferReservations(payload)
      this.latestReservations = response
      this.lastReservationCancelToken = null
    } catch (e) {
      if ((e as any).isCancel(e )) {

      } else {
        this.showSnackBar = true
        this.snackBarColor = 'error'
        this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
      }

    }
  }

  async acceptRequest (status: string): Promise<void> {
    const payload: RequestPayload = {
      id: this.request.id,
      status:`/api/request-status-kind/${status}`,
      dataOverride: {
        firstName:this.boarderRequest!.data.firstName,
        familyName:this.boarderRequest!.data.familyName,
        email:this.boarderRequest!.data.email,
        customer:`api/customer/${this.currentCustomer!.id}`,
        boarderGroup:`/api/boarder-group/${this.currentBoarderGroup.id}`,
        phoneNumber: this.boarderRequest!.data.phoneNumber,
        existingBoarder: this.selectedBoarder ? `/api/food-ordering/boarder/${this.selectedBoarder!.id}` : null
      }

    }
    try {
      this.isCreate = true
      if(payload.status === 'approved' && this.selectedBoarder) {
        await this.acceptedRequest(payload)
      }else if(payload.status === 'rejected' && this.selectedBoarder) {
        await this.acceptedRequest(payload)
      } else {
        await this.acceptedRequest(payload)
      }

    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('discountPage.errorSaveMessage').toString()
    } finally {
      this.isCreate = false
      this.isSnackbar = true
      this.onCloseButtonClick(this.isSnackbar,payload.status.replace('/api/request-status-kind/', ''))
    }
  }

  async fetchBoarder (): Promise<void> {
    try {
      this.isLoading = true
      this.boarderListActual = await this.fetchBoarderGroupList()
        const foundBorderGroup: PersonDetail | undefined = this.boarderListActual.find((item: any) => item.id == this.boarderRequest!.data.boarderGroup.replace('/api/boarder-group/', ''))
        this.currentBoarderGroup = foundBorderGroup ? foundBorderGroup : null
      this.isLoading = false


    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
    }
  }

  async fetchCustomer (): Promise<void> {
    try {
      this.isLoading = true
      this.customerListActual = await this.fetchCustomerList()
        const foundCustomer: Customer | undefined = this.customerListActual.find((item: any) => item.id == this.boarderRequest!.data.customer.replace('/api/customer/', ''))
      this.currentCustomer = foundCustomer ? foundCustomer : null
      this.isLoading = false

    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('businessPage.fetchDataError').toString()
    }
  }

  mounted() {
    this.boarderRequest = this.request
    this.fetchArchiveList()
    this.name = this.boarderRequest.data.firstName + ' ' + this.boarderRequest.data.familyName
    this.searchBoarder = _.debounce(this.searchBoarder, 800)
    this.fetchCustomer()
    this.fetchBoarder()

  }
}

</script>

<style lang="stylus" scoped>
.loader
  position absolute
  padding-top 250px
</style>
